const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

class LyleEditorial5050 extends HTMLElement {
  #motionQuery = null;

  connectedCallback() {
    this.#motionQuery = window.matchMedia(REDUCED_MOTION_QUERY);
    this.#motionQuery.addEventListener(
      "change",
      this.#handleMotionPreferenceChange,
    );
    this.#applyVideoAutoplayPreference();
  }

  disconnectedCallback() {
    this.#motionQuery?.removeEventListener(
      "change",
      this.#handleMotionPreferenceChange,
    );
    this.#motionQuery = null;
  }

  #handleMotionPreferenceChange = () => {
    this.#applyVideoAutoplayPreference();
  };

  #applyVideoAutoplayPreference() {
    const videos = this.querySelectorAll(".editorial-50-50__video");

    for (const video of videos) {
      if (!(video instanceof HTMLVideoElement)) continue;

      if (!this.#motionQuery?.matches) continue;

      video.removeAttribute("autoplay");
      video.pause();
    }
  }
}

if (!customElements.get("lyle-editorial-50-50")) {
  customElements.define("lyle-editorial-50-50", LyleEditorial5050);
}
